import { style } from '@angular/animations';
import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WeCallYouComponent } from '@app/@shared/components/we-call-you/we-call-you.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nav-tooltip-sell',
  templateUrl: './nav-tooltip-sell.component.html',
  styleUrls: ['./nav-tooltip-sell.component.scss'],
})
export class NavTooltipSellComponent implements OnDestroy {
  private langChangeSubscription: Subscription;
  language!: string;
  @Output() closeTooltip = new EventEmitter<boolean>();

  // Configuración de posiciones por idioma
  get tooltipArrowPositionSell() {
    const positions: { [key: string]: string } = {
      es: '260px', // Español
      en: '225px', // Inglés
    };
    return positions[this.language] || '260px';
  }

  get classMb5() {
    const positions: { [key: string]: string } = {
      es: 'mb-5', // Español
      en: '', // Inglés
    };
    return positions[this.language];
  }

  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.language = this.translateService.currentLang;
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event) => {
        this.language = event.lang;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  goNavigateToUrl(url: string) {
    const customCreateUrl = `/${this.language}/${url}`;
    this.router.navigate([customCreateUrl]);
    this.closeTooltip.emit(false);
  }

  openCallModal() {
    this.closeTooltip.emit(false);
    this.dialog.open(WeCallYouComponent, {
      maxWidth: '95vw',
      panelClass: 'noPadding',
    });
  }
}
